import {
  Component,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../services/notification.service';
import { AdminService } from '../../services/admin.service';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { emailValidator } from '../../shared/custom-validator/email.validator';
import { ConfirmedValidator } from '../../shared/custom-validator/password.validator';

export interface UsersData {
  first_name: string;
  middle_name: string;
  last_name: string;
  age: number;
  gender: string;
  address: string;
  role: string;
  designation: string;
  email: string;
  telephone: string;
  office_no: string;
  mobile: string;
  password: string;
}

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css'],
})
export class CreateUserComponent implements OnInit, AfterViewInit, OnDestroy {
  usersList = [];
  emailList = [];
  telePhoneNo = [];
  officeNo = [];
  mobileNo = [];
  showorhideModal = false;
  // dataSource = [];
  displayedColumns: string[] = [
    'name',
    // "role",
    'designation',
    'email',
    'mobile',
    'edit',
    'update'
    // "delete",
  ];

  public dataSource = new MatTableDataSource<any>();
  userProfile: any;

  editEnable = false;
  onEdit = true;
  userId: any;
  changePassword = false;

  oldDesignation: string;

  userListSubs: Subscription;
  userProfileSubs: Subscription;
  updateUserSubs: Subscription;
  deleteUserSubs: Subscription;
  userSearchSubs: Subscription;

  refreshUsers$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  userSearch$: Subject<string> = new Subject<string>();

  userForm: FormGroup;
  passUpdateForm: FormGroup;
  userFormSubmitted = false;
  passFormSubmitted = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('createUserFormCard') createUserFormCard!: ElementRef<HTMLDivElement>;
  @ViewChild('firstNameInput') firstNameInput!: ElementRef<HTMLInputElement>;
  @ViewChild('updatePasswordFormCard') updatePasswordFormCard!: ElementRef<HTMLDivElement>;
  @ViewChild('newPasswordInput') newPasswordInput!: ElementRef<HTMLInputElement>;
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private notification: NotificationService
  ) { }

  public doFilter = (value: string) => {
    this.userSearch$.next(value);
  }

  ngOnInit(): void {
    this.loadUsers();
    this.userSearchSubs = this.userSearch$
      .pipe(debounceTime(350), distinctUntilChanged())
      .subscribe((searchTerm) => this.loadUsers(searchTerm));

    this.passUpdateForm = this.fb.group({
      newpassword: [null, [Validators.required, Validators.minLength(8)]],
      cnfnewPassword: [null]
    },
      {
        validator: ConfirmedValidator('newpassword', 'cnfnewPassword')
      }
    );

    this.userForm = this.fb.group({
      first_name: [null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z ]+$/),
        this.noWhitespaceOnlyValidator(),
        this.noEdgeWhitespaceValidator()
      ]],
      middle_name: [null, [
        Validators.maxLength(50),
        Validators.pattern(/^$|^[A-Za-z ]+$/),
        this.noEdgeWhitespaceOptionalValidator()
      ]],
      last_name: [null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z ]+$/),
        this.noWhitespaceOnlyValidator(),
        this.noEdgeWhitespaceValidator()
      ]],
      email: [null, [Validators.required, Validators.email, Validators.pattern(/^\S+@\S+\.\S+$/), emailValidator(this.emailList)]],
      age: [null, [Validators.required, Validators.min(18), Validators.max(100)]],
      gender: [null, [Validators.required]],
      office_no: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(10),
          Validators.pattern('^[0-9]+$'),
          // officeNoValidator(this.officeNo)
        ]),
      ],
      mobile: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(10),
          Validators.pattern('^[0-9]+$'),
          // mobileNoValidator(this.mobileNo)
        ]),
      ],
      // telephone: [null,[Validators.required,telephoneNoValidator(this.telePhoneNo)]],
      telephone: [null, [Validators.pattern(/^$|^[0-9]{10,12}$/)]],
      address: [null, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(250),
        Validators.pattern(/^[A-Za-z0-9 ,./#-]+$/),
        this.noWhitespaceOnlyValidator(),
        this.noEdgeWhitespaceValidator()
      ]],
      role: [null, [Validators.required]],
      designation: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(8)]],
    });

    // this.userForm.statusChanges.subscribe((status) => console.log(status));
  }

  private loadUsers(searchTerm: string = ''): void {
    if (this.userListSubs) {
      this.userListSubs.unsubscribe();
    }

    this.userListSubs = this.adminService.getAllUsers(searchTerm).subscribe((res) => {
      console.log(res);
      this.emailList = [];
      this.usersList = [];

      for (let index = 0; index < res.length; index++) {
        this.emailList.push(res[index].email);
      }

      this.dataSource.data = res as UsersData[];
      if (this.paginator) {
        this.paginator.firstPage();
      }
      this.usersList.push(...res);
    });
  }

  get f() {
    return this.passUpdateForm.controls;
  }

  private noWhitespaceOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value ?? '').toString();
      return value.trim().length > 0 ? null : { whitespace: true };
    };
  }

  private noEdgeWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return value === value.trim() ? null : { edgeWhitespace: true };
    };
  }

  private noEdgeWhitespaceOptionalValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return value === value.trim() ? null : { edgeWhitespace: true };
    };
  }

  isUserControlInvalid(controlName: string): boolean {
    const control = this.userForm.get(controlName);
    return !!control && control.invalid && (control.touched || this.userFormSubmitted);
  }

  hasUserError(controlName: string, errorName: string): boolean {
    const control = this.userForm.get(controlName);
    return !!control && control.hasError(errorName) && (control.touched || this.userFormSubmitted);
  }

  private markFormGroupTouched(control: AbstractControl): void {
    control.markAsTouched();
    if (control instanceof FormGroup) {
      Object.values(control.controls).forEach((child) =>
        this.markFormGroupTouched(child)
      );
    }
  }

  trimControl(controlName: string): void {
    const control = this.userForm.get(controlName);
    if (!control) { return; }
    const value = control.value;
    if (typeof value === 'string') {
      control.setValue(value.trim());
    }
  }

  private sanitizeUserFormData() {
    const trimKeys = [
      'first_name',
      'middle_name',
      'last_name',
      'email',
      'address',
      'telephone',
    ];
    trimKeys.forEach((key) => this.trimControl(key));
  }

  private setCreateUserValidators(): void {
    this.userForm.get('email')?.setValidators([
      Validators.required,
      Validators.email,
      Validators.pattern(/^\S+@\S+\.\S+$/),
      emailValidator(this.emailList),
    ]);
    this.userForm.get('age')?.setValidators([Validators.required, Validators.min(18), Validators.max(100)]);
    this.userForm.get('gender')?.setValidators([Validators.required]);
    this.userForm.get('office_no')?.setValidators([
      Validators.required,
      Validators.maxLength(12),
      Validators.minLength(10),
      Validators.pattern('^[0-9]+$'),
    ]);
    this.userForm.get('mobile')?.setValidators([
      Validators.required,
      Validators.maxLength(12),
      Validators.minLength(10),
      Validators.pattern('^[0-9]+$'),
    ]);
    this.userForm.get('address')?.setValidators([
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(250),
      Validators.pattern(/^[A-Za-z0-9 ,./#-]+$/),
      this.noWhitespaceOnlyValidator(),
      this.noEdgeWhitespaceValidator(),
    ]);
    this.userForm.get('designation')?.setValidators([Validators.required]);
    this.userForm.get('password')?.setValidators([Validators.required, Validators.minLength(8)]);
    this.updateUserFormValidity();
  }

  private setEditUserValidators(): void {
    this.userForm.get('email')?.setValidators([
      Validators.required,
      Validators.email,
      Validators.pattern(/^\S+@\S+\.\S+$/),
    ]);
    this.userForm.get('age')?.setValidators([Validators.min(18), Validators.max(100)]);
    this.userForm.get('gender')?.clearValidators();
    this.userForm.get('office_no')?.setValidators([
      Validators.maxLength(12),
      Validators.pattern('^[0-9]+$'),
    ]);
    this.userForm.get('mobile')?.setValidators([
      Validators.maxLength(12),
      Validators.pattern('^[0-9]+$'),
    ]);
    this.userForm.get('address')?.setValidators([
      Validators.minLength(5),
      Validators.maxLength(250),
      Validators.pattern(/^[A-Za-z0-9 ,./#-]+$/),
      this.noEdgeWhitespaceOptionalValidator(),
    ]);
    this.userForm.get('designation')?.clearValidators();
    this.userForm.get('password')?.clearValidators();
    this.updateUserFormValidity();
  }

  private updateUserFormValidity(): void {
    ['email', 'age', 'gender', 'office_no', 'mobile', 'address', 'designation', 'password'].forEach((controlName) => {
      this.userForm.get(controlName)?.updateValueAndValidity();
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  private scrollAndFocusCreateUserForm(): void {
    const formCard = this.createUserFormCard?.nativeElement;
    if (formCard) {
      formCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setTimeout(() => {
      const firstName = this.firstNameInput?.nativeElement;
      if (firstName) {
        firstName.focus();
        firstName.setSelectionRange(firstName.value.length, firstName.value.length);
      }
    }, 250);
  }

  private scrollAndFocusUpdatePasswordForm(): void {
    setTimeout(() => {
      const formCard = this.updatePasswordFormCard?.nativeElement;
      if (formCard) {
        formCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      const newPassword = this.newPasswordInput?.nativeElement;
      if (newPassword) {
        newPassword.focus();
      }
    }, 250);
  }

  // getUsers() {
  //   this.adminService.getAllUsers().then((res) => {
  //     this.usersList = res;
  //   });
  // }



  editUser(id) {
    this.emailList = [];
    this.telePhoneNo = [];
    this.officeNo = [];
    this.mobileNo = [];
    this.userId = id;
    this.userProfileSubs = this.adminService
      .getUserProfile(id)
      .subscribe((res) => {
        this.editEnable = true;
        this.onEdit = false;
        this.userFormSubmitted = false;
        this.setEditUserValidators();
        this.userProfile = res;
        this.userForm.reset();
        this.userForm.patchValue({
          first_name: res.first_name,
          middle_name: res.middle_name,
          last_name: res.last_name,
          email: res.email,
          age: res.age,
          gender: res.gender,
          office_no: res.office_no,
          mobile: res.mobile,
          telephone: res.telephone,
          address: res.address,
          role: res.role,
          designation: res.designation,
          // password: res.password,
        });
        this.oldDesignation = res.designation;
        console.log(this.oldDesignation);
        this.scrollAndFocusCreateUserForm();
      });
  }

  onUpdateUser() {
    this.userFormSubmitted = true;
    this.sanitizeUserFormData();
    this.markFormGroupTouched(this.userForm);
    if (this.userForm.invalid) {
      this.notification.showNotification(
        'top',
        'right',
        'error',
        'Please fix validation errors before updating the user.'
      );
      return;
    }
    const data = { ...this.userForm.value };
    if (!data.password) {
      delete data.password;
    }
    this.updateUserSubs = this.adminService
      .updateUserProfile(this.userId, data)
      .subscribe(
        (res) => {
          this.userForm.reset();
          this.userFormSubmitted = false;
          this.userForm.markAsPristine();
          this.userForm.markAsUntouched();
          console.log(res);
          const newDesiigantion: string = res.designation;
          console.log(newDesiigantion);
          this.onEdit = true;
          this.notification.showNotification(
            'top',
            'right',
            'success',
            'Detail posted successfully!!!'
          );
          this.editEnable = !this.editEnable;
          this.setCreateUserValidators();
          this.userForm.updateValueAndValidity();
          this.loadUsers();
          if (this.oldDesignation !== newDesiigantion) {
            console.log('Designation changed');
            const updateUserList = { id: this.userId };
            this.adminService
              .updateUserDesignation(updateUserList)
              .subscribe((designationResponse) => {
                console.log(designationResponse);
              });
          } else {
            console.log('Designation remains same!');
          }
        },
        (err) => {
          console.error(err.error.message);
          this.notification.showNotification(
            'top',
            'right',
            'error',
            err.error.message
          );
        }
      );
  }

  deleteUser() {
    this.deleteUserSubs = this.adminService.deleteUser(this.userId).subscribe((res) => {
      console.log('User Deleted!!!');
      console.log(res, 'User Deleted!!!');
      this.userForm.reset();
      this.userFormSubmitted = false;
      this.userForm.markAsPristine();
      this.userForm.markAsUntouched();
      this.setCreateUserValidators();
      this.editEnable = false;
      this.notification.showNotification(
        'top',
        'right',
        'success',
        'User deleted successfully!!!'
      );
      this.showorhideModal = false;
      this.loadUsers();
    });
  }

  showpopup() {
    this.showorhideModal = true;
  }

  hidepopup() {
    this.showorhideModal = false;
  }

  onResetForm() {
    this.userForm.reset();
    this.userFormSubmitted = false;
    this.setCreateUserValidators();
    this.editEnable = false;
    this.onEdit = true;
  }

  postUserDataToSuitableTable(userData) {
    const designation = userData.designation;
    if (designation === 'Principal secretary') {
      const userInfo = {
        principal: userData.userId,
      };
      this.adminService.createPrincipalSec(userInfo).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'Comissioner') {
      const comm = {
        comissioner: userData.userId,
      };
      this.adminService.createComissioner(comm).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'District collector') {
      const userInfo = {
        district_collector: userData.userId,
      };
      this.adminService.createDistrictCollector(userInfo).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'Cala') {
      const userInfo = {
        cala: userData.userId,
      };
      this.adminService.createCALA(userInfo).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'Executive engineer') {
      const userInfo = {
        executive_engineer: userData.userId,
      };
      this.adminService.createExecutiveEngg(userInfo).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'Regional officer') {
      const userInfo = {
        regional_officer: userData.userId,
      };
      this.adminService.createRegionalOfficer(userInfo).subscribe((res) => {
        console.log(res);
      });
    } else if (designation === 'TILR') {
      const userInfo = {
        tilr: userData.userId,
      };
      this.adminService.createTILR(userInfo).subscribe((res) => {
        console.log(res);
      });
    }
  }

  onSubmitUserForm() {
    this.userFormSubmitted = true;
    this.sanitizeUserFormData();
    this.markFormGroupTouched(this.userForm);
    if (this.userForm.invalid) {
      this.notification.showNotification(
        'top',
        'right',
        'error',
        'Please fix validation errors before submitting.'
      );
      return;
    }
    const data = this.userForm.value;
    console.log(data, 'user form data');

    this.adminService.createUser(data).subscribe(
      (res) => {
        console.log(res);
        const userData = {
          designation: res.designation,
          userId: res.id,
        };
        console.log(userData);
        this.postUserDataToSuitableTable(userData);
        this.notification.showNotification(
          'top',
          'right',
          'success',
          'Detail posted successfully!!!'
        );
        this.userForm.reset();
        this.userFormSubmitted = false;
      },
      (err) => {
        console.error(err);
        this.notification.showNotification(
          'top',
          'right',
          'error',
          'User with this email address already exists!'
        );
      }
    );
  }

  // on pass update

  editpass(id) {
    this.userId = id;
    this.changePassword = true;
    this.scrollAndFocusUpdatePasswordForm();
  }


  onResetpassForm() {
    this.passUpdateForm.reset();
    this.passFormSubmitted = false;
    this.changePassword = false;
  }

  onSubmitpassupdate() {
    this.passFormSubmitted = true;
    this.markFormGroupTouched(this.passUpdateForm);
    if (this.passUpdateForm.invalid) {
      return;
    }

    console.log(this.passUpdateForm.value, 'pass update value');
    const data = {
      id: this.userId,
      password: this.passUpdateForm.value.newpassword
    };
    this.adminService.updatepassword(data).subscribe((res) => {
      // console.log(res,'password update res');
      this.notification.showNotification(
        'top',
        'right',
        'success',
        'Password updated successfully!!!'
      );
      this.passUpdateForm.reset();
      this.changePassword = false;
    },
      (err) => {
        console.error(err);
      });
  }

  ngOnDestroy() {
    if (this.userListSubs) {
      this.userListSubs.unsubscribe();
    }
    if (this.userSearchSubs) {
      this.userSearchSubs.unsubscribe();
    }
    // this.userProfileSubs.unsubscribe();
    // this.updateUserSubs.unsubscribe();
    // this.deleteUserSubs.unsubscribe();
  }
}
